import { TOAST_TIMEOUT} from '../constants';

export function errorToast(toast, message) {
  toast({
    title: 'Error',
    description: message,
    status: 'error',
    duration: TOAST_TIMEOUT,
    isClosable: true,
  });
}
export function successToast(toast, date) {
  toast({
    title: 'Habit recorded',
    description: `You have recorded your habit for ${new Date(date).toDateString()}`,
    status: 'success',
    duration: TOAST_TIMEOUT,
    isClosable: true,
  });
}
